var Carousel = (function ($) {
  var _carousels;

  var init = () => {
    _selectCarousels();
    _initCarousels();
  };

  var _selectCarousels = () => {
    _carousels = $('.carousel');
  };

  var _initCarousels = () => {
    if (_carousels.length) {
      $.each(_carousels, (index, value) => {
        $(value).flickity({
          autoPlay: 3000,
          adaptiveHeight: true,
          cellSelector: '.carousel-cell',
          draggable: false,
          imagesLoaded: true,
          pageDots: false,
          pauseAutoPlayOnHover: true,
          wrapAround: true,
        });
      });
    }
  };

  module.exports = {
    init: init,
  };
})(jQuery);
